import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import Grid from '../Grid';
import Button from '../Button';

interface IJobData {
  /**
   * @alais parent job id
   */
  col0?: number;
  /**
   * @alais 스크랩 상품 코드
   */
  col1: string;
  /**
   * @alias 스크랩 성공 여부
   */
  col2: string;
  /**
   * @alais 스크랩 실패 메시지
   */
  col3?: string;
  /**
   * @alais 스크랩 상품 url
   */
  col4: string;
  /**
   * @alais
   */
  col5: string;
  /**
   * @alais 등록 실패 여부
   */
  col6: string;
  /**
   * @alais 등록 실패 메시지
   */
  col7: string;
  /**
   * @alais 조회 시 순서 id
   */
  id: number;
}
interface IProps {
  headerItems: Array<{
    width: number;
    align: 'left' | 'center' | 'right';
    headerAlign: 'left' | 'center' | 'right';
    headerName: string;
    editable?: boolean;
    hideable?: boolean;
  }>;
  bodyItems: any[][];
  onSelectionChange?: (selectedRows: any[]) => void;
}
const GridTag = styled(Grid)`
  height: 390px;
  /* overflow-y: scroll; */
  border: 1px solid #e2e2e2;
  border-radius: 5px;

  .MuiDataGrid-root * {
    font-size: 0.77rem;
  }
`;

export default function TableCheckBoxComponent(props: IProps) {
  const hideableIndexs: number[] = [];
  const [gogoRows, setGogoRows] = useState<IJobData[]>([]);
  // 체크박스 상태 관리
  const [checkedStates, setCheckedStates] = useState<{ [key: number]: boolean }>({});

  const columns: GridColDef[] = useMemo(
    () => [
      {
        field: 'checkbox',
        headerName: '선택',
        width: 50, // 체크박스의 너비 설정
        renderCell: (params) => {
          return (
            <input
              type="checkbox"
              checked={!!checkedStates[params.row.id]} // 체크박스 상태에 따라 checked 속성 설정
              onChange={(target) => {
                handleCheckboxChange(params.row, target.target.checked);
              }}
            />
          );
        },
        align: 'center',
        headerAlign: 'center',
        sortable: false,
        disableColumnMenu: true,
      },
      ...props.headerItems
        .filter((item, index) => {
          // 숨길 컬럼의 index를 기록후
          // 노출할 컬럼만 filter에서 반환함
          if (item.hideable) {
            hideableIndexs.push(index);
          }
          return !item.hideable;
        })
        .map((one, index) => ({
          field: `col${index}`,
          headerName: one.headerName,
          width: one.width,
          align: one.align,
          headerAlign: one.headerAlign,
          editable: one.editable,
          sortable: false,
          disableColumnMenu: true,
        })),
    ],
    [props.headerItems, checkedStates],
  );

  const rows = useMemo(
    () =>
      props.bodyItems
        ? props.bodyItems.map((row, index) => {
            let rowIndex = 0;
            return row.reduce((all, current, index2) => {
              all.id = index;
              // 숨길 컬럼은 bodyItem 배열 요소에서 포함시키지 않음
              if (!hideableIndexs.includes(index2)) {
                all[`col${rowIndex}`] = current;
                rowIndex++;
              }
              return all;
            }, {} as any);
          })
        : [],
    [props.bodyItems],
  );

  const handleCheckboxChange = (row: any, isChecked: boolean) => {
    setCheckedStates((prevStates) => ({
      ...prevStates,
      [row.id]: isChecked,
    }));
    // 체크박스가 선택되었으면 row를 추가하고, 선택 해제되었으면 해당 row를 제거
    if (isChecked) {
      setGogoRows((prevRows) => [...prevRows, row]);
    } else {
      setGogoRows((prevRows) => prevRows.filter((gogoRow) => gogoRow.id !== row.id));
    }
  };

  async function onClick() {
    if (props.onSelectionChange) {
      props.onSelectionChange(gogoRows);
    }
    // 모든 체크박스의 체크 해제
    setCheckedStates({});
    // 배열 초기화
    setGogoRows([]);
  }

  return (
    <>
      <GridTag>
        <DataGrid columns={columns} rows={rows} hideFooter />
      </GridTag>
      <div style={{ margin: '10px 0 30px', display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          onClick={(event) => {
            event.preventDefault(); // 기본 동작 방지
            onClick();
          }}
          color="main"
          variant="contained"
          size="medium"
          width={105}
          borderRadius={0}
        >
          적용
        </Button>
      </div>
    </>
  );
}
